export default __webpack_public_path__ + "static/media/logoBPayHorizontal40.8b764997.svg";